const setLoader = (isLoading) => (state, action) => {
  state.isLoading = isLoading;
};

export const setLoaderTrue = setLoader(true);
export const setLoaderFalse = setLoader(false);
